import { render, staticRenderFns } from "./LiveMapVesselDetails.vue?vue&type=template&id=010530c2&scoped=true&"
import script from "./LiveMapVesselDetails.vue?vue&type=script&lang=js&"
export * from "./LiveMapVesselDetails.vue?vue&type=script&lang=js&"
import style0 from "./LiveMapVesselDetails.vue?vue&type=style&index=0&id=010530c2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010530c2",
  null
  
)

export default component.exports